import { type FileWithPath } from 'react-dropzone';

export const toAnimatedOnboardingUploadFiles = (files: readonly File[]): FileWithPath[] =>
  files.map((file) => {
    const relativePath = file.webkitRelativePath;

    if (!relativePath) {
      return file;
    }

    return Object.assign(file, { path: relativePath });
  });
